import { Box, Divider, Flex } from "@chakra-ui/react";
import { Sidebar } from "@root/components/dashboard/sidebar";
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { DashboardLayoutContainter } from "./styles";

import SectionHeader from "@root/components/kpec-admin/subscriber-management/sectionheader";
import useMediaQ from "@root/hooks/useMediaQ";
import MobileHeader from "@root/components/kpec-admin/subscriber-management/mobileHeader";
import MobileFooter from "@root/components/dashboard/sidebar/mobileFooter";
import { MobileSideMenu } from "@root/components/dashboard/sidebar/MobileSideMenu";
import { CommonFooter } from "@root/components/auth/commonFooter";
const DashboardLayout: React.FC = () => {
  const filePopOverStatus: boolean = true;
  const { sm } = useMediaQ();
  const isMobile = !sm;
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const globalClickHandlet = () => {
    if (filePopOverStatus) {
      // dispatch(filePopOverHandler(false));
    }
  };
  return (
    <DashboardLayoutContainter onClick={globalClickHandlet}>
      <Flex flex={1} width={"100%"}>
        {!isMobile && (
          <Box className="left-box" p={"12px"}>
            <Sidebar />
          </Box>
        )}

        {/* Vertical Divider */}
        <Divider orientation="vertical" borderColor="gray.300" height="100%" />

        <Flex flex={1} bgColor={"#A7BBC80F"} flexDirection={"column"}>
          <Flex
            overflowY={"auto"}
            className="right-box"
            flex={1}
            flexDir={"column"}
          >
            {isMobile ? (
              <MobileHeader
                onMenuClick={() => setIsSideMenuOpen(true)}
                showHamburger={true}
              />
            ) : (
              <Box w="100%">
                <SectionHeader />
              </Box>
            )}
            <Box flex={1} overflowY="auto">
              <Outlet />
            </Box>
          </Flex>
          <CommonFooter />
        </Flex>
      </Flex>

      {/* Mobile Bottom Navigation Footer if asked by client
      {isMobile && <MobileFooter />} */}

      {/* Mobile Side Menu */}
      {isMobile && (
        <MobileSideMenu
          isOpen={isSideMenuOpen}
          onClose={() => setIsSideMenuOpen(false)}
        />
      )}
    </DashboardLayoutContainter>
  );
};

export default DashboardLayout;
